import { Module } from "vuex";
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import router from "@/router";

const reportModule: Module<any, any> = {
  namespaced: false,
  state: {
    reports: [],
    currentreport: null,
  },

  mutations: {
    setreports(state: any, payload: []) {
      state.reports = payload;
    },

    setCurrentreport(state: any, payload: []) {
      state.currentreport = payload;
    },
  },

  actions: {
    async getReports({ commit }) {
      const reports = firebase.firestore().collection("reports")
      .where("facilityId", "==", this.state.authModule.currentFacility);
      await reports.get().then((querySnapshot) => {
        const reportList: Array<any> = [];

        querySnapshot.docs.forEach((x) => {
          const thisRes = x.data();
          thisRes.id = x.id;
          reportList.push(thisRes);
        });
        commit("setreports", reportList);
      });
    },

    async getreport({ commit }, id) {
      const reports = firebase.firestore().collection("reports").doc(id);
      await reports.get().then((querySnapshot) => {
        const currentreport = querySnapshot.data();
        if (currentreport != null) {
          currentreport.id = querySnapshot.id;
          commit("setCurrentreport", currentreport);
        }
      });

      router.push("/reports-views/" + id);
    },
    async saveCurrentreportConfig({commit}, currentreport){
      commit("setCurrentreportUnsavedreportTemplate", currentreport);
    }
  },
};
export default reportModule;
